// extracted by mini-css-extract-plugin
export default {"optionBtn":"style_optionBtn__yqV1I","options":"style_options__plaLl","optionBtn__delete":"style_optionBtn__delete__QQ-ex"};